import { Button, useNotify, useRedirect } from "react-admin";
import ModalComponent from "../../../components/ModalComponent";
import React from "react";

const ConfirmDeletePanelModal = ({ open, onClose, panelId, panelName, labName }) => {
    const notify = useNotify();
    const redirect = useRedirect();
    const [loading, setLoading] = React.useState(false);

    const handleDeletePanel = async () => {
        setLoading(true);
        try {
            const apiUrl = process.env.REACT_APP_API_URL || '';
            const response = await fetch(`${apiUrl}/panels/${panelId}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });
            const messageBack = await response.text();
            if (!response.ok) {
                let errorMsg = 'Erro ao excluir painel';
                try {
                    const parsed = JSON.parse(messageBack);
                    if (parsed && parsed.message) {
                        errorMsg = parsed.message;
                    } else if (messageBack) {
                        errorMsg = messageBack;
                    }
                } catch {
                    if (messageBack) errorMsg = messageBack;
                }
                throw new Error(errorMsg);
            }
            notify(`Painel '${panelName}' foi excluído com sucesso`, { type: 'success' });
            onClose();
            redirect('/panels');
            
        } catch (error) {
            notify(error.message || 'Erro ao excluir painel', { type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <ModalComponent
            open={open}
            onClose={onClose}
            title={
                <span style={{ fontWeight: '600', color: '#D32F2F' }}>
                    Confirmar Exclusão de Painel
                </span>
            }
            content={
                <div>
                    <p>
                        Tem certeza que deseja excluir o painel <strong>{panelName}</strong>
                        {' '}do laboratório <strong>{labName}</strong>? Esta operação é irreversível.
                    </p>
                </div>
            }
            actions={
                <>
                    <Button onClick={onClose} label="Cancelar" disabled={loading} />
                    <Button 
                        onClick={handleDeletePanel} 
                        label="Excluir" 
                        variant="outlined" 
                        color="error" 
                        disabled={loading} 
                    />
                </>
            }
        />
    );
};

export default ConfirmDeletePanelModal;
